// Utils/Helpers
import { AUTHORIZATION_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '@/constants/common';
import appCookiesStorage from './appCookies';

// Models
import { ROUTES } from '@/models/router.model';

/** Токен считаем протухшим чуть заранее, чтобы не отправлять запрос с истекающим на лету токеном */
const TOKEN_EXPIRATION_SKEW_MS = 30 * 1000;

const decodeTokenPayload = (token: string): Record<string, unknown> | null => {
  const payload = token.split('.')[1];

  if (!payload) return null;

  try {
    return JSON.parse(window.atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
};

/**
 * Протух ли JWT по клеймy `exp`.
 * Если токена нет — считаем протухшим, если распарсить не удалось — доверяем решение бэкенду.
 */
export const isTokenExpired = (token?: string): boolean => {
  if (!token) return true;

  const exp = decodeTokenPayload(token)?.exp;

  if (typeof exp !== 'number') return false;

  return Date.now() >= exp * 1000 - TOKEN_EXPIRATION_SKEW_MS;
};

export const getAuthToken = () => appCookiesStorage.getItem(AUTHORIZATION_TOKEN_STORAGE_KEY);

export const getRefreshToken = () => appCookiesStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);

export const setAuthToken = (token: string) => appCookiesStorage.setItem(AUTHORIZATION_TOKEN_STORAGE_KEY, token);

export const clearSession = () => {
  appCookiesStorage.removeItem(AUTHORIZATION_TOKEN_STORAGE_KEY);
  appCookiesStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  localStorage.clear();
};

/**
 * Полный сброс сессии с переходом на логин.
 * Используется вне React-дерева (интерсепторы), поэтому редирект делаем через window.location —
 * так гарантированно сбрасывается и redux-стейт с закешированными данными.
 */
let isSignOutInProgress = false;

export const forceSignOut = () => {
  if (isSignOutInProgress) return;

  isSignOutInProgress = true;
  clearSession();

  if (window.location.pathname !== ROUTES.SIGN_IN) {
    window.location.replace(ROUTES.SIGN_IN);
  } else {
    isSignOutInProgress = false;
  }
};
